import { AcademicCapIcon } from "@heroicons/react/solid";

const obj = {
  title: "Rent Review",
  desc: "Use this tool for rent review documentation",
  category: "trilogy",
  Icon: AcademicCapIcon,
  // tags: [],
  permissions: ["user"],

  fromColor: "purple-400",
  toColor: "purple-600",

  to: "/ai/writing/rentreview",
  api: "/ai/writing/rentreview",

  output: {
    title: "Prompt Builder",
    desc: "Please wait as we query AI models. This can take up to 2 minutes.",
    // Icon: RefreshIcon,
    // color: "",
  },

  prompts: [
    {
      title: "Rent Review",
      desc: "Enter your essay response",
      // n: 1,
      prompts: [
        {
          title: "Rent Review (Upload .pdf of the mark scheme).",
          name: "scheme", // This should match the multer configuration on the server
          attr: "scheme", // This should match the multer configuration on the server
          value: "",
          label: "Upload your PDF file",
          type: "file",
          required: true,
          error: "",
        },
      ],
      example: {
        output: ".", // outputs: [],
        // Icon: RefreshIcon,
        // color: "",
      },
    },
  ],
};

export default obj;
